import { useSelector } from 'react-redux';
import { Suggestions, Suggestion } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';

const BucketSearchResults = ({
  onSuggestionClick,
  search,
  showSuggestions
}) => {
  const currentCategory = useSelector(s => s.plpUI.current);
  const bucketModelNumberResults = useSelector(
    s => s.categories.byId[currentCategory]?.bucketModelNumber
  );

  const renderSearchResults = () => {
    if (showSuggestions) {
      const filteredBucketNumbers = bucketModelNumberResults.filter(
        ({ label }) => label.includes(search)
      );
      const orderedBucketNumbers = filteredBucketNumbers.sort(
        ({ label: firstLabel }, { label: nextLabel }) =>
          firstLabel.indexOf(search) - nextLabel.indexOf(search)
      );
      const slicedBucketNumbers = orderedBucketNumbers.slice(0, 6);
      return slicedBucketNumbers.map(({ label, facet }) => (
        <Suggestion
          key={facet}
          highlight={search}
          onClick={() => onSuggestionClick(label, facet)}
          text={label}
        />
      ));
    }
    return [];
  };

  return showSuggestions && <Suggestions>{renderSearchResults()}</Suggestions>;
};

BucketSearchResults.propTypes = {
  onSuggestionClick: PropTypes.func,
  search: PropTypes.string,
  showSuggestions: PropTypes.bool
};

export default BucketSearchResults;
